<template>
  <div :class="classes" :style="styles">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'c-kicker',
  props: {
    color: {
      type: String,
      default: '#88D49E',
    },
    weight: {
      type: String,
      default: '700',
      description: '(100-800 / bolder / lighter / normal)',
    },
    align: {
      type: String,
      default: 'left',
    },
    size: {
      type: String,
      default: 'md',
      validator: (value) => ['xs', 'sm', 'md', 'lg', 'xl'].includes(value),
    },
  },
  computed: {
    classes() {
      return [
        'c-kicker',
        `c-kicker--${this.weight}`,
        `c-kicker--${this.align}`,
        `c-kicker--size-${this.size}`,
      ]
    },
    styles() {
      return {
        color: this.color,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.c-kicker {
  line-height: 1.225rem;

  @media screen and (min-width: 1200px) {
    line-height: 1.75rem;
  }

  &--size-xs {
    font-size: 0.75rem;

    @media screen and (min-width: 1200px) {
      font-size: 1rem;
    }
  }

  &--size-sm {
    font-size: 0.8125rem;

    @media screen and (min-width: 1200px) {
      font-size: 1.125rem;
    }
  }

  &--size-md {
    font-size: 0.875rem;

    @media screen and (min-width: 1200px) {
      font-size: 1.25rem;
    }
  }

  &--size-lg {
    font-size: 1rem;

    @media screen and (min-width: 1200px) {
      font-size: 1.375rem;
    }
  }

  &--size-xl {
    font-size: 1.125rem;

    @media screen and (min-width: 1200px) {
      font-size: 1.5rem;
    }
  }
}
</style>
